import { create, get } from '@github/webauthn-json';

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.content : null;
}

function getJSON(url) {
  return fetch(url, { headers: { Accept: 'application/json' } }).then(response => response.json());
}

function postJSON(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken()
    },
    body: JSON.stringify(body)
  }).then(response =>
    response.json().then(data => {
      if (!response.ok) {
        throw new Error((data.errors && data.errors[0]) || 'Something went wrong, please try again.');
      }
      return data;
    })
  );
}

// Detects whether the current browser supports WebAuthn passkeys.
export function supported() {
  return typeof globalThis !== 'undefined' && !!globalThis.PublicKeyCredential;
}

// Registers a new passkey for the currently signed in user.
//
// - optionsUrl: endpoint returning the WebAuthn credential creation options
// - createUrl: endpoint that verifies and persists the created credential
// - nickname: a user supplied label for the passkey (e.g. "Work laptop")
export function registerPasskey({ optionsUrl, createUrl, nickname }) {
  optionsUrl = optionsUrl.split('?')[0];
  createUrl = createUrl.split('?')[0];
  return getJSON(optionsUrl)
    .then(credentialOptions => create({ publicKey: credentialOptions }))
    .then(credential => postJSON(createUrl, { ...credential, nickname }));
}

// Signs in using a previously registered passkey.
//
// - optionsUrl: endpoint returning the WebAuthn credential request options
// - sessionUrl: endpoint that verifies the assertion and signs the user in
export function signInWithPasskey({ optionsUrl, sessionUrl }) {
  optionsUrl = optionsUrl.split('?')[0];
  sessionUrl = sessionUrl.split('?')[0];

  return getJSON(optionsUrl)
    .then(credentialOptions => get({ publicKey: credentialOptions }))
    .then(credential => postJSON(sessionUrl, credential));
}
